/* eslint-disable no-undef */
'use client';

import type {
  DialogCloseProps,
  DialogContentProps,
  DialogOverlayProps,
  DialogPortalProps,
  DialogProps,
  DialogTriggerProps,
} from '@radix-ui/react-dialog';
import * as DialogPrimitive from '@radix-ui/react-dialog';

import type { DrawerProps, DrawerSide } from './drawer.types';

export const DrawerRoot = DialogPrimitive.Root as (
  props: DialogProps,
) => React.ReactNode;

export const DrawerTrigger = DialogPrimitive.Trigger as (
  props: DialogTriggerProps & React.RefAttributes<HTMLButtonElement>,
) => React.ReactNode;

const DrawerPortal = DialogPrimitive.Portal as (
  props: DialogPortalProps,
) => React.ReactNode;

export const DrawerClose = DialogPrimitive.Close as (
  props: DialogCloseProps & React.RefAttributes<HTMLButtonElement>,
) => React.ReactNode;

const DrawerOverlay = DialogPrimitive.Overlay as (
  props: DialogOverlayProps & React.RefAttributes<HTMLDivElement>,
) => React.ReactNode;

const DrawerContentPrimitive = DialogPrimitive.Content as (
  props: DialogContentProps & React.RefAttributes<HTMLDivElement>,
) => React.ReactNode;

export function DrawerContent({
  children,
  closeText,
  side = 'left',
  ref,
  ...props
}: DrawerProps & {
  children: React.ReactNode;
  ref?: React.Ref<HTMLDivElement>;
}) {
  const stylesMap: Record<DrawerSide, string> = {
    left: 'fixed inset-y-0 left-0 z-50 flex flex-col bg-gray-0 data-[state=closed]:animate-hide-left data-[state=open]:animate-show-left mini:right-0 mobile:right-auto',
    right:
      'fixed inset-y-0 right-0 z-50 flex flex-col bg-gray-0 data-[state=closed]:animate-hide-right data-[state=open]:animate-show-right mini:left-0 mobile:left-auto',
  };

  return (
    <DrawerPortal>
      <DrawerOverlay className="fixed inset-0 z-50 bg-primary-950 opacity-50 data-[state=closed]:animate-fade-out-5 data-[state=open]:animate-fade-in-5" />
      <DrawerContentPrimitive className={stylesMap[side]} ref={ref} {...props}>
        <DrawerClose
          aria-label="Close"
          className="flex w-full justify-end p-24-24"
        >
          {closeText}
        </DrawerClose>
        {children}
      </DrawerContentPrimitive>
    </DrawerPortal>
  );
}
